import * as actions from "./actions";
import * as getters from "./getters";
import mutations from "./mutations";

export const state = {
  all: [],
  displayBoard: [],
  templates: [],
  url_participant: null,
  url_moderateur: null,
  current: {},
  background64: "",
  currentViewMap: {
    x: 0,
    y: 0
  },
  currentSheet: -1,
  currentBoardPost: [],
  currentBoardPostWaiting: [],
  isconnected: false,
  editing: false,
  isActive: false,
  queueIsDisplayed: true,
  trashcanIsDisplayed: false,
  isChoosingPlace: false,
  isLoading: true,
  popupPostAction: false,
  currentSelectedColor: "rgb(153,204,204)",
  newPostit: {
    contenu: "",
    coord_x: 0,
    coord_y: 0,
    sheet_id: "",
    etat: "attente",
    link: ""
  },
  linking: {
    isLinking: false,
    currentParent: null,
    currentChild: null
  },
  menu: {
    selecting: false,
    drawing: false,
    erasing: false,
    linkSimple: false,
    linkHier: false,
    modeArrow: false,
    modeWriting: false,
    textWriting: false,
    rightClicked: false,
    linking: false
  },
  selectedPosts: [],
  folders: [],
  selectedTextsAndDrawings: [],
  editedboard: {
    id: null,
    name: "",
    mode: "libre",
    id_plateforme: null,
    id_entreprise: null,
    colours: [
      "rgb(112,209,248)",
      "rgb(238,110,110)",
      "rgb(96,205,199)",
      "rgb(245,235,153)",
      "rgb(223,173,53)",
      "rgb(96,76,141)",
      "rgb(76,108,160)"
    ],
    active: 1,
    shares: [],
    open_at: null,
    close_at: null,
    closeBoard: 0,
    template_id: null
  },
  isImageModalActive: false,
  ImageModalSrc: null,
  currentTemplate: null,
  loadingOrderedList: false,
  boardIsClosed: false
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/board/index.js